import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { Create } from './components/Create'
import { useHookTable } from './hook'
import { useGetHeightTable } from 'app/hook'
import { FilterLayout } from 'app/components/tables/BaseTableManagement/FilterManagementTableV2'
const JobTitleLevelManagementContainer = () => {
  const {
    tableData,
    columns,
    handleTableChange,
    fetchNewData,
    filter,
    handleChangeFilter,
  } = useHookTable()
  return (
    <S.BaseManagementWrapper>
      <S.RootWrapper size={8}>
        <BaseRow align={'middle'} gutter={16} justify={'space-between'}>
          <BaseCol>
            <FilterLayout
              handleChangeFilter={handleChangeFilter}
              filterData={filter}
            />
          </BaseCol>
          <BaseCol>
            <BaseRow gutter={16}>
              {/* <BaseCol>

              </BaseCol> */}
              <BaseCol>
                <Create fetchTable={fetchNewData} />
              </BaseCol>
            </BaseRow>
          </BaseCol>
        </BaseRow>
        <BaseTableManagement
          columns={columns}
          dataSource={tableData.data}
          pagination={tableData.pagination}
          loading={tableData.loading}
          onChange={handleTableChange}
          scroll={{
            x: true,
            y: tableData?.data?.length ? useGetHeightTable(195, 30) : undefined,
          }}
        />
      </S.RootWrapper>
    </S.BaseManagementWrapper>
  )
}
export default JobTitleLevelManagementContainer
